import { ICourseRequirement, ICreateCourseRequirement } from '@/types/courses';

export const getRequirementMapBySession = (
  requirements: (ICourseRequirement | ICreateCourseRequirement)[] | undefined
) => {
  return (
    requirements?.reduce<Record<number, string[]>>((acc, req) => {
      if (acc[req.session_id]) {
        acc[req.session_id].push(req.type);
      } else {
        acc[req.session_id] = [req.type];
      }
      return acc;
    }, {}) ?? {}
  );
};
